import { useEffect, useState } from 'react';
import headers, { getSpace } from '../../common/headers';
import { TableTop5 } from '../../components/TableTop5/TableTop5';
import { CardMetricVersion2 } from '../../components/CardsComponents/CardMetricVersion2/CardMetricVersion2';
import { KonstantinMasterHttps } from '../../fetchUrls';
import { WrapperLineChart } from '../../charts/WrapperCharts/WrapperLineChart/WrapperLineChart';
import { WrapperDoughnutChart } from '../../charts/WrapperCharts/WrapperDoughnutChart/WrapperDoughnutChart';
import useGeneralStore from '../../store/general';
import { msToLocalDate } from '../../common/constant';
import './AdvancedAnalytics.scss';

const AdvancedAnalytics = ({
  date,
  selectedBrand,
  selectedCategory,
  selectedApi,
  selectedMarketplace,
  pageValue,
  pageContent,
  allPeriod,
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const [fivePositivePhrase, setFivePositivePhrase] = useState([]);
  const [fiveNegativePhrase, setFiveNegativePhrase] = useState([]);
  const [top5NegRating, setTop5NegRating] = useState([]);
  const [top5WithoutFeedbacks, setTop5WithoutFeedbacks] = useState([]);
  const [metrics, setMetrics] = useState([])
  const [loadingMetrics, setLoadingMetrics] = useState(false)

  const body_obj = () => {

    let api_id_list;
    let mp_id_list;
    let category_id_list;
    const [date_from, date_to] = date;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    }

    if (selectedMarketplace?.length > 0) {
      mp_id_list = selectedMarketplace?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    const body = JSON.stringify({
      mp_id_list,
      api_id_list,
      category_id_list,
      date_from: allPeriod
        ? new Date(0)
        : msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
    });
    if (selectedApi?.length > 0) {
      return body
    } else {
      return null
    }
  }

  useEffect(() => {
    if (selectedApi?.length > 0) {
      body_obj()
    }
  }, [
    date,
    selectedBrand,
    selectedCategory,
    selectedApi,
    selectedMarketplace,
    allPeriod,
  ]);

  const fetchAdvAnalyticsTop5NegRating = async () => {
    if (!selectedApi.length) {
      return;
    }
    let url = `${KonstantinMasterHttps}/wb/feedbacks/analytics/tables/adv-analytics-top-5-neg-rating`;

    let api_id_list;
    let mp_id_list;
    let category_id_list;
    let brand_id_list;
    const [date_from, date_to] = date;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    }

    if (selectedMarketplace?.length > 0) {
      mp_id_list = selectedMarketplace?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    const body = JSON.stringify({
      filters: [],
      mp_id_list,
      api_id_list,
      category_id_list,
      brand_id_list,
      date_from: allPeriod
        ? new Date(0)
        : msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
      page: 1,
      limit: 5,
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { ...headers, ...getSpace(selectedSpace) },
        body,
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(JSON.stringify(err));
      }

      const json = await response.json();
      setTop5NegRating(json);
      console.log(json);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAdvAnalyticsTop5WithoutFeedbacks = async () => {
    if (!selectedApi.length) {
      return;
    }
    let url = `${KonstantinMasterHttps}/wb/feedbacks/analytics/tables/adv-analytics-top-5-without-feedbacks`;

    let api_id_list;
    let mp_id_list;
    let category_id_list;
    let brand_id_list;
    const [date_from, date_to] = date;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    }

    if (selectedMarketplace?.length > 0) {
      mp_id_list = selectedMarketplace?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    const body = JSON.stringify({
      filters: [],
      mp_id_list,
      api_id_list,
      category_id_list,
      brand_id_list,
      date_from: allPeriod
        ? new Date(0)
        : msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
      page: 1,
      limit: 5,
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { ...headers, ...getSpace(selectedSpace) },
        body,
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(JSON.stringify(err));
      }

      const json = await response.json();
      setTop5WithoutFeedbacks(json);
      console.log(json);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMetric = async () => {
    if (!selectedApi.length) {
      return;
    }
    setMetrics([])
    setLoadingMetrics(true)
    let url = `${KonstantinMasterHttps}/wb/feedbacks/analytics/plots/avg-rating-all-feedback`;

    let api_id_list;
    let mp_id_list;
    let category_id_list;
    let brand_id_list;
    const [date_from, date_to] = date;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    }

    if (selectedMarketplace?.length > 0) {
      mp_id_list = selectedMarketplace?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    const body = JSON.stringify({
      mp_id_list,
      api_id_list,
      category_id_list,
      brand_id_list,
      date_from: allPeriod
        ? new Date(0)
        : msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { ...headers, ...getSpace(selectedSpace) },
        body,
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(JSON.stringify(err));
      }

      const json = await response.json();
      setMetrics(json);
      setLoadingMetrics(false)
    } catch (err) {
      setLoadingMetrics(false)
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAdvAnalyticsTop5NegRating();
    fetchAdvAnalyticsTop5WithoutFeedbacks();
    fetchMetric()
  }, [
    date,
    selectedBrand,
    selectedCategory,
    selectedApi,
    selectedMarketplace,
    allPeriod,
  ]);

  return (
    <div className="advanced-analytics">
      <div className="advanced-analytics__table-chart-cards-group">
        <WrapperDoughnutChart
          url={`${KonstantinMasterHttps}/wb/${pageValue}/analytics/plots/grades-received`}
          body={body_obj()}
          nameChart="Полученые оценки"
        />

        <WrapperLineChart
          url={`${KonstantinMasterHttps}/wb/${pageValue}/analytics/plots/feedback-received`}
          body={body_obj()}
          nameChart="Полученые отзывы"
        />

        <div className="advanced-analytics__table-chart-cards-group_cards">
          {metrics.length > 0 ? metrics.map(({ labels, data }) => {
            return <CardMetricVersion2
              title={labels?.header[0]}
              value={data}
            // type={'rating'}
            />
          })
            :
            [...Array(2)].map((el) => {
              return <CardMetricVersion2
                title={''}
                value={[]}
              // type={'rating'}
              />
            })
          }
        </div>
      </div>

      <div className="advanced-analytics__chart-group">
        <div className="advanced-analytics__chart-group_line">
          <WrapperLineChart
            url={`${KonstantinMasterHttps}/wb/${pageValue}/analytics/plots/reviews-per-day`}
            body={body_obj()}
            nameChart="Отзывов за день"
          />
        </div>
        <div className="advanced-analytics__chart-group_doughnut">
          <WrapperDoughnutChart
            url={`${KonstantinMasterHttps}/wb/${pageValue}/analytics/plots/reviews-on-marketplaces`}
            body={body_obj()}
            nameChart="Отзывы по маркетплейсам"
          />
        </div>
      </div>

      {/* <div className="advanced-analytics__chart-group">
        <WrapperLineChart
          url={`${KonstantinMasterHttps}/wb/${pageValue}/analytics/plots/graph-sentiments`}
          body={body_obj()}
          nameChart="График положительных и отрицательных тональностей"
        />
      </div> */}

      {/* <div className="advanced-analytics__table-and-chart-group">
        <div className="advanced-analytics__chart-group">
          <WrapperLineChart
            url={`${KonstantinMasterHttps}/wb/${pageValue}/analytics/plots/graph-sentiments`}
            body={body_obj()}
            nameChart="График положительных и отрицательных тональностей"
          />
        </div>

        <div className="advanced-analytics__table-group">
          <TableTop5
            title="ТОП-5 положительных фраз"
            data={fivePositivePhrase}
          />
          <TableTop5
            title="ТОП-5 отрицательных фраз"
            data={fiveNegativePhrase}
          />
        </div>
      </div> */}

      <div className="advanced-analytics__table-group">
        <TableTop5
          title="ТОП-5 товаров, по которым были отрицательные оценки"
          data={top5NegRating}
        />
        <TableTop5
          title="ТОП-5 товаров, по которым долгое время не было отзывов"
          data={top5WithoutFeedbacks}
        />
      </div>
    </div>
  );
};

export { AdvancedAnalytics };
